import React from "react";
import TimeAgo from 'react-timeago';
import arabicStrings from 'react-timeago/lib/language-strings/ar';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import get from "lodash/get";
import { Link, ResponsiveImage } from "@quintype/components";
import { format } from "date-fns";
import { getAuthorTemplate } from '../author/get-author-template';
// Author component can accept these params.
// isLink : Basically changes the component clickable in any scenario.
// author : An author object which will have name, id, date & image.
// authors: An array of authors which will come from story API itself. If the authors array is present we'll ignore the author object.
// showDateOnly: Will hide the `Posted` string infront of every date.
// date   : pass the date value from story object
function Author(props) {
  // If there's only one author.
  const storyTypeKey = props.textStory === 'default' || !props.textStory ? '' : `${props.textStory}-`;
  if((props.author && !props.authors) || (props.authors && props.authors.length === 1)) {
    const author = props.authors ? props.authors[0] : props.author;
    return props.isLink ? <Link href={'/author/' + author.id}>
      { React.createElement(getAuthorTemplate(`${storyTypeKey}single-author`), Object.assign({}, { config: props.config, author }, props)) }
    </Link> : React.createElement(getAuthorTemplate(`${storyTypeKey}single-author`), Object.assign({}, { config: props.config, author }, props));
  }
  // If there're mulitiple authors.
  if(props.authors && props.authors.length !== 1) {
    return React.createElement(getAuthorTemplate(`${storyTypeKey}multi-author`), props);
  }
  // fallback
  return null;
}

export { Author };
